import schema, { generateType } from './Schema';
export const Profile = generateType(schema.getModel('profile'));
//# sourceMappingURL=ProfileModel.js.map